export default __webpack_public_path__ + "static/media/BER.b6a85ac9.svg";